const ProcessingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
    >
      <g
        id="Group_94062"
        data-name="Group 94062"
        transform="translate(-30 -100)"
      >
        <g
          id="Group_93058"
          data-name="Group 93058"
          transform="translate(0 -184)"
          opacity="0"
        >
          <g
            id="Business_s_Icon"
            data-name="Business's_Icon"
            transform="translate(-1790 95)"
            opacity="0"
          >
            <g
              id="Rectangle_24795"
              data-name="Rectangle 24795"
              transform="translate(1820 189)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
              opacity="0"
            >
              <rect width="23" height="23" stroke="none" />
              <rect x="0.5" y="0.5" width="22" height="22" fill="none" />
            </g>
            <g id="team-leader" transform="translate(1820 189)">
              <g id="Team_Leader_1_" transform="translate(1.328)">
                <g
                  id="Group_92575"
                  data-name="Group 92575"
                  transform="translate(0 2.745)"
                >
                  <path
                    id="Path_140327"
                    data-name="Path 140327"
                    d="M32.657,67.313a2.657,2.657,0,1,1,2.657-2.657A2.659,2.659,0,0,1,32.657,67.313Z"
                    transform="translate(-30 -62)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_92576"
                  data-name="Group 92576"
                  transform="translate(14.7 2.745)"
                >
                  <path
                    id="Path_140328"
                    data-name="Path 140328"
                    d="M364.657,67.313a2.657,2.657,0,1,1,2.657-2.657A2.659,2.659,0,0,1,364.657,67.313Z"
                    transform="translate(-362 -62)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_92577"
                  data-name="Group 92577"
                  transform="translate(6.686)"
                >
                  <path
                    id="Path_140329"
                    data-name="Path 140329"
                    d="M184.321,6.642a3.321,3.321,0,1,1,3.321-3.321A3.325,3.325,0,0,1,184.321,6.642Z"
                    transform="translate(-181)"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_140330"
                  data-name="Path 140330"
                  d="M156.313,151.516V156.1a.664.664,0,0,1-1.328,0v-4.582A4.642,4.642,0,0,0,151,156.1v3.985a.664.664,0,0,0,.664.664h1.488l.507,6.122a.664.664,0,0,0,.662.608h2.657a.664.664,0,0,0,.662-.608l.507-6.122h1.488a.664.664,0,0,0,.664-.664V156.1A4.642,4.642,0,0,0,156.313,151.516Z"
                  transform="translate(-145.642 -144.807)"
                  fill="#fff"
                />
              </g>
              <path
                id="Path_140331"
                data-name="Path 140331"
                d="M5.313,189.306v-3.985a5.9,5.9,0,0,1,.7-2.747A3.942,3.942,0,0,0,3.985,182,3.989,3.989,0,0,0,0,185.985v3.321a.664.664,0,0,0,.664.664h.727l.6,6.044a.664.664,0,0,0,.661.6H5.313a.664.664,0,0,0,.661-.6l.491-4.908A1.99,1.99,0,0,1,5.313,189.306Z"
                transform="translate(0 -173.941)"
                fill="#fff"
              />
              <path
                id="Path_140332"
                data-name="Path 140332"
                d="M372.451,185.985A3.989,3.989,0,0,0,368.466,182a3.942,3.942,0,0,0-2.028.574,5.9,5.9,0,0,1,.7,2.747v3.985a1.991,1.991,0,0,1-1.152,1.8l.491,4.908a.664.664,0,0,0,.661.6h2.657a.664.664,0,0,0,.661-.6l.6-6.044h.727a.664.664,0,0,0,.664-.664Z"
                transform="translate(-349.781 -173.941)"
                fill="#fff"
              />
            </g>
          </g>
          <g id="credit-card" transform="translate(30 205.18)">
            <g
              id="Group_93057"
              data-name="Group 93057"
              transform="translate(0 82.82)"
            >
              <path
                id="Path_140371"
                data-name="Path 140371"
                d="M21.312,82.82H1.688A1.69,1.69,0,0,0,0,84.508V96.691a1.69,1.69,0,0,0,1.688,1.688H21.312A1.69,1.69,0,0,0,23,96.691V84.508A1.69,1.69,0,0,0,21.312,82.82ZM7.075,92.951h2.28a.5.5,0,0,1,0,.991H7.075a.5.5,0,0,1,0-.991ZM2.142,87.983a.5.5,0,0,1,.5-.5H5.6a.5.5,0,0,1,.5.5v2.145a.5.5,0,0,1-.5.5H2.637a.5.5,0,0,1-.5-.5Zm.5,4.968h2.28a.5.5,0,0,1,0,.991H2.637a.5.5,0,0,1,0-.991Zm8.14,3.193H2.637a.5.5,0,0,1,0-.991h8.14a.5.5,0,0,1,0,.991Zm3.016-2.2h-2.28a.5.5,0,0,1,0-.991h2.28a.5.5,0,0,1,0,.991Zm4.438,0h-2.28a.5.5,0,0,1,0-.991h2.28a.5.5,0,0,1,0,.991Zm2.132-7.235H14.985a.5.5,0,1,1,0-.991h5.378a.5.5,0,0,1,0,.991Z"
                transform="translate(0 -82.82)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
        <g id="team" transform="translate(-0.318 100)">
          <g
            id="Group_94047"
            data-name="Group 94047"
            transform="translate(31.318 12.907)"
          >
            <g id="Group_94046" data-name="Group 94046">
              <path
                id="Path_140545"
                data-name="Path 140545"
                d="M51.5,288.77v-1.452H44.812a3.4,3.4,0,0,1-6.8,0H31.318v1.452l2.906.308a7.354,7.354,0,0,0,.861,2.078l-1.838,2.273,2.053,2.053,2.273-1.838a7.354,7.354,0,0,0,2.078.861l.308,2.906h2.9l.308-2.906a7.354,7.354,0,0,0,2.078-.861l2.273,1.838,2.053-2.053-1.838-2.273a7.354,7.354,0,0,0,.861-2.078Z"
                transform="translate(-31.318 -287.318)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94049"
            data-name="Group 94049"
            transform="translate(38.804)"
          >
            <g id="Group_94048" data-name="Group 94048">
              <path
                id="Path_140546"
                data-name="Path 140546"
                d="M200.574,0a2.607,2.607,0,1,0,2.607,2.607A2.61,2.61,0,0,0,200.574,0Z"
                transform="translate(-197.967)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94051"
            data-name="Group 94051"
            transform="translate(36.318 5.935)"
          >
            <g id="Group_94050" data-name="Group 94050">
              <path
                id="Path_140547"
                data-name="Path 140547"
                d="M150.488,132.109h-5.551a2.32,2.32,0,0,0-2.318,2.318v3.307h10.187v-3.307A2.32,2.32,0,0,0,150.488,132.109Z"
                transform="translate(-142.619 -132.109)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94053"
            data-name="Group 94053"
            transform="translate(33.545 1.204)"
          >
            <g id="Group_94052" data-name="Group 94052">
              <path
                id="Path_140548"
                data-name="Path 140548"
                d="M83.235,26.808a2.335,2.335,0,0,0-.031,4.67,3.666,3.666,0,0,1,2.082-1.219,2.335,2.335,0,0,0-2.051-3.451Z"
                transform="translate(-80.9 -26.808)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94055"
            data-name="Group 94055"
            transform="translate(31.318 6.521)"
          >
            <g id="Group_94054" data-name="Group 94054">
              <path
                id="Path_140549"
                data-name="Path 140549"
                d="M33.394,145.154a2.079,2.079,0,0,0-2.076,2.076v2.962H34.97v-3.307a3.642,3.642,0,0,1,.436-1.732H33.394Z"
                transform="translate(-31.318 -145.154)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94057"
            data-name="Group 94057"
            transform="translate(44.606 1.204)"
          >
            <g id="Group_94056" data-name="Group 94056">
              <path
                id="Path_140550"
                data-name="Path 140550"
                d="M329.461,26.808a2.335,2.335,0,0,0-2.051,3.451,3.666,3.666,0,0,1,2.082,1.219,2.335,2.335,0,0,0-.031-4.67Z"
                transform="translate(-327.126 -26.808)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_94059"
            data-name="Group 94059"
            transform="translate(47.416 6.521)"
          >
            <g id="Group_94058" data-name="Group 94058">
              <path
                id="Path_140551"
                data-name="Path 140551"
                d="M391.69,145.154h-2.012a3.642,3.642,0,0,1,.436,1.732v3.307h3.652V147.23A2.079,2.079,0,0,0,391.69,145.154Z"
                transform="translate(-389.678 -145.154)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ProcessingIcon;